import {useContext, createContext} from 'react';
export const DraftContentContext = createContext<Record<string, any>>({});

export function useDraftContent() {
  const context = useContext(DraftContentContext);

  if (!context) {
    throw new Error('No draft context found');
  }

  return context;
}

export default function DraftContentProvider({
  value,
  children,
}: {
  value: Record<string, any>;
  children: React.ReactNode;
}) {
  return (
    <DraftContentContext.Provider value={value}>
      {children}
    </DraftContentContext.Provider>
  );
}
